// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__LVlhT","button_update":"styles_button_update__2KDzX"};